export default {
    install(app) {
        app.config.globalProperties.$initTawkTo = function () {
            if (typeof window.Tawk_API === 'undefined' && !document.querySelector('script[src*="embed.tawk.to"]')) {
                var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
                s1.async = true;
                s1.src = 'https://embed.tawk.to/65fc1c53a0c6737bd1234535/1hpgctae9';
                s1.charset = 'UTF-8';
                s1.setAttribute('crossorigin', '*');
                s0.parentNode.insertBefore(s1, s0);

                s1.onload = () => {
                    console.log("Tawk.to script loaded.");
                };
            }
        };
    }
};
